<template>
  <div class="frame-page h-full !m-0px p-20px flex flex-column">
    <vxe-toolbar class-name="px-8px">
      <template #buttons>
        <vxe-button @click="showForm()" content="新增" status="primary" icon="fa fa-plus"/>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">日期：</span>
          <DateRangePicker v-model="dateRange"/>
        </div>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">转出账户：</span>
          <Select class="w-120px" :datas="accountList" keyName="id" titleName="name" v-model="query.outAccountId">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
        </div>
        <div class="h-input-group ml-8px">
          <span class="h-input-addon">转入账户：</span>
          <Select class="w-120px" :datas="accountList" keyName="id" titleName="name" v-model="query.inAccountId">
            <template #show="{value}">{{ value.code }} - {{ value.name }}</template>
            <template #item="{item}">{{ item.code }} - {{ item.name }}</template>
          </Select>
        </div>
        <vxe-button :loading="loading" @click="doSearch" class="ml-8px" content="查询" icon="fa fa-search" status="primary"/>
      </template>
      <template #tools>
        <vxe-button @click="printList()" content="打印" icon="fa fa-print"/>
        <!--        <vxe-button content="导出" icon="fa fa-download"/>-->
        <!--        <vxe-button content="导入" icon="fa fa-upload"/>-->
        <vxe-button @click="batchDelete" content="批量删除" icon="fa fa-trash"/>
        <!--        <vxe-button content="生成凭证" status="primary"/>-->
      </template>
    </vxe-toolbar>
    <div class="flex-1">
      <vxe-table ref="xTable" :loading="loading" :data="results.results" height="auto">
        <vxe-column type="checkbox" width="50" align="center"/>
        <vxe-column field="transferDate" width="120" title="日期"/>
        <vxe-column field="digest" title="摘要"/>
        <vxe-column field="outAccount" width="150" title="转出账户"/>
        <vxe-column field="inAccount" width="150" title="转入账户"/>
        <vxe-column field="amount" width="120" align="right" title="金额" formatter="toMoney"/>
        <vxe-column field="remark" title="备注"/>
        <vxe-column field="voucherTitle" title="关联凭证" width="100" align="center"/>
        <vxe-column field="id" title="操作" width="100" align="center">
          <template #default="{row}">
            <div class="actions">
              <span @click="showForm(row)">编辑</span>
              <span @click="remove(row)">删除</span>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <vxe-pager @page-change="onPageChange"
               v-model:current-page="page.page"
               v-model:page-size="page.pageSize"
               :total="results.total"
               :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
      <template #left>
        <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
      </template>
    </vxe-pager>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "InternalTransfer"
}
</script>

<script setup>
import {layer} from "@layui/layer-vue";
import {h, ref} from "vue";
import InternalTransferForm from "@/views/cashier/transfer/InternalTransferForm";
import CashierTransfer from "@/api/CashierTransfer";
import CashierAccount from "@/api/CashierAccount";
import manba from "manba";
import {confirm, message} from "heyui.ext";
import {useStore} from "vuex";
import Qs from "qs";

const store = useStore();
const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
const startDate = ref(currentAccountDate.startOf(manba.MONTH).format());
const endDate = ref(currentAccountDate.endOf(manba.MONTH).format());

const loading = ref(false);
const xTable = ref(null);
const accountList = ref([]);
const results = ref({
  results: [],
  total: 0,
});

const page = ref({
  page: 1,
  pageSize: 20
})

const query = ref({
  outAccountId: null,
  inAccountId: null
})
const dateRange = ref({
  start: startDate.value,
  end: endDate.value
})


const loadList = () => {
  loading.value = true;
  CashierTransfer.list(Object.assign(page.value, query.value, dateRange.value)).then(({data}) => {
    results.value = data;
  }).finally(() => loading.value = false)
}
loadList();

const onPageChange = ({currentPage, pageSize}) => {
  page.value.page = currentPage;
  page.value.pageSize = pageSize;
  loadList();
}

const doSearch = () => {
  page.value.page = 1;
  loadList();
}

const showForm = (entity = null) => {
  let layerId = layer.open({
    title: "转账信息",
    shadeClose: false,
    closeBtn: false,
    zIndex: 1000,
    area: ['500px', 'auto'],
    content: h(InternalTransferForm, {
      entity, accountList: accountList.value,
      onClose: () => {
        layer.close(layerId);
      },
      onReload: () => {
        loadList();
      },
      onSuccess: () => {
        loadList();
        layer.close(layerId);
      }
    })
  });
}

CashierAccount.list().then(({data}) => {
  accountList.value = data;
})

const printList = () => {
  window.open("/api/pdf/transfer/list?" + Qs.stringify(Object.assign(page.value, query.value, dateRange.value), {arrayFormat: 'repeat'}))
}

const remove = (row) => {
  confirm({
    content: "确定删除此记录?",
    async: true,
    onConfirm(resolve) {
      CashierTransfer.delete(row.id).then(() => {
        resolve(true)
        loadList();
      }).catch(() => {
        resolve(false)
      })
    }
  })
}

const batchDelete = (row) => {
  let records = xTable.value.getCheckboxRecords().map(row => row.id);
  if (records.length) {
    confirm({
      content: "确定删除此记录?",
      async: true,
      onConfirm(resolve) {
        CashierTransfer.batchDelete(records).then(() => {
          resolve(true)
          loadList();
        }).catch(() => {
          resolve(false)
        })
      }
    })
  } else {
    message.warn("请先选择记录~");
  }
}
</script>
